import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/Pnls/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class PnlsQueries extends VueCqrs
{
	runCorporatePnlTemplatesByStrategyIdQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildCorporatePnlTemplatesByStrategyIdQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runCorporatePnlTemplateByIdQueryV1(workspaceId: number, strategyId: string, pnlId: string)
	{
		const query = q.buildCorporatePnlTemplateByIdQueryV1(workspaceId, strategyId, pnlId);
		this.$query(query);
	}

	runPnlsPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildPnlsPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runDefaultPnlTemplateByIdQueryV1(workspaceId: number, strategyId: string, templateId: string)
	{
		const query = q.buildDefaultPnlTemplateByIdQueryV1(workspaceId, strategyId, templateId);
		this.$query(query);
	}
}